import { Link } from "react-router-dom";

// Swiper Slider
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

SwiperCore.use([Autoplay, Pagination]);

export default function HomeSlider() {
  const Slide1 = () => (
    <div className="w-full flex">
      <div className="w-full max-w-[350px] lg:max-w-[410px]">
        <img src="/images/unlock.webp" className="w-full h-full object-cover" />
      </div>
      <div className="flex-1 flex flex-col bg-primary-700 py-6 lg:py-10 px-8 lg:px-10">
        <div className="text-base md:text-2xl text-white font-bold mb-1 lg:mb-4">
          Unlock Exclusive Early Bird Discounts!"
        </div>
        <div className="text:sm md:text-lg text-white mb-6">
          Book Early to Save Big on Your Next Adventure with Maraliner!"
        </div>
        <div className="flex items-end gap-16">
          <div className="max-w-[420px] flex flex-col">
            <Link
              to=""
              className="max-w-fit bg-[#191F26] text-sm text-white font-medium py-2 lg:py-3 px-3 lg:px-4 rounded-[4px] mb-3 lg:mb-4"
            >
              Book Now
            </Link>
            <div className="text-sm md:text-base text-white">
              *Discounts may vary depending on the route and travel dates.
            </div>
          </div>
          <div className="flex flex-col gap-3 lg:gap-6">
            <div className="flex items-center gap-2 lg:gap-6">
              <Link to="/">
                <img src="/images/app-store.svg" alt="app store" />
              </Link>
              <div className="bg-[#EFEFEF] p-0.5 rounded-[4px]">
                <img src="/images/qr-app-store.png" alt="" />
              </div>
            </div>
            <div className="flex items-center gap-2 lg:gap-6">
              <Link to="/">
                <img src="/images/play-store.svg" alt="app store" />
              </Link>
              <div className="bg-[#EFEFEF] p-0.5 rounded-[4px]">
                <img src="/images/qr-play-store.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const Slide2 = () => (
    <div className="w-full flex bg-white shadow-block">
      <div className="flex-1 flex flex-col py-6 lg:py-[52px] px-10 lg:px-[60px]">
        <div className="text-[32px] font-semibold text-black mb-2">
          Earn up to RM50
        </div>
        <div className="text-[#858585] text-lg mb-8">
          Invite your friends to Maraliner app
        </div>
        <Link
          to=""
          className="w-full max-w-[178px] p-3 bg-primary-700 text-white text-base font-semibold flex items-center justify-center rounded-[10px]"
        >
          Refer Now
        </Link>
      </div>
      <div className="w-full max-w-[50%] h-[294px]">
        <img src="/images/earn.webp" className="w-full h-full object-cover" />
      </div>
    </div>
  );

  const Slide3 = () => (
    <div className="w-full flex bg-white shadow-block">
      <div className="flex-1 flex flex-col py-6 lg:py-[52px] px-10 lg:px-[60px]">
        <div className="text-[32px] font-semibold text-black mb-2">
          Carnival 2024 Lucky Draw
        </div>
        <div className="text-[#858585] text-lg mb-8">
          Validity date is until 27 th May until 4th June 2024
        </div>
        <Link
          to=""
          className="w-full max-w-[178px] p-3 bg-primary-700 text-white text-base font-semibold flex items-center justify-center rounded-[10px]"
        >
          Learn more
        </Link>
      </div>
      <div className="w-full max-w-[50%] h-[294px]">
        <img
          src="/images/lucky-draw.webp"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );

  return (
    <div className="w-full mb-[40px]">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        autoplay={true}
        pagination={{ clickable: true }}
        className="home-slider"
      >
        <SwiperSlide>
          <Slide1 />
        </SwiperSlide>

        <SwiperSlide>
          <Slide2 />
        </SwiperSlide>

        <SwiperSlide>
          <Slide3 />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
